<template>
  <div class="container-fluid container-fluid px-4 rounded-4 contenedor-principal">

    <EmpresasColaboradorasGrid :tipoEmpresaAgente="props.tipoEmpresaAgente"
      v-if="tipoEmpresaAgenteEnum === 'COLABORADORES'" />
    <EmpresasInmobiliariasGrid :tipoEmpresaAgente="props.tipoEmpresaAgente"
      v-if="tipoEmpresaAgenteEnum === 'INMOBILIARIAS'" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import EmpresasColaboradorasGrid from "@/components/empresas-agentes/EmpresasColaboradorasGrid.vue";
import EmpresasInmobiliariasGrid from "@/components/empresas-agentes/EmpresasInmobiliariasGrid.vue";

const props = defineProps({
  tipoEmpresaAgente: String
});

const tipoEmpresaAgenteEnum = computed(() => props.tipoEmpresaAgente?.toUpperCase());
</script>